import { render } from "./TimelineColumns.vue?vue&type=template&id=2bb8ab3c&scoped=true"
import script from "./TimelineColumns.vue?vue&type=script&lang=js"
export * from "./TimelineColumns.vue?vue&type=script&lang=js"

import "./TimelineColumns.vue?vue&type=style&index=0&id=2bb8ab3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb8ab3c"]])

export default __exports__